import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/wave.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/download.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
export default {
  name: 'Characteristics',
  props: {
    dangerousProduct: {
      type: String,
      default: ''
    },
    dangerousProductTranslated: {
      type: String,
      default: ''
    },
    infoCompDescription: {
      type: String,
      default: ''
    },
    infoCompLabel: {
      type: String,
      default: ''
    },
    specificityLogo: {
      type: Object,

      default() {
        return {};
      }

    },
    documents: {
      type: Array,

      default() {
        return [];
      }

    },
    videos: {
      type: Array,

      default() {
        return [];
      }

    },
    detailsSize: {
      type: Number,
      default: 0
    },
    commonDetails: {
      type: Object,

      default() {
        return null;
      }

    },
    isInfoComp: {
      type: Boolean,
      default: null
    }
  },

  data() {
    return {
      isPlaying: false,
      imagesPath: 'https://cdn.maisonsdumonde.com/images/segmentations/'
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    hasVideos() {
      return this.videos !== null && this.videos.length;
    },

    detailsCommon() {
      return Object.entries(this.commonDetails).reduce((details, _ref) => {
        let [key, value] = _ref;

        if (key === 'document') {
          return details;
        }

        return _objectSpread({}, details, {
          [key]: value
        });
      }, {});
    }

  }),
  methods: {
    labels: _labels => Object.values(_labels).filter(label => label.description)
  }
};